import { createApp, h } from 'vue'
import NotificationToast from '@/components/NotificationToast.vue'

interface ToastOptions {
  type?: 'success' | 'error' | 'warning' | 'info'
  title: string
  message: string
  duration?: number
}

class ToastManager {
  private container: HTMLDivElement | null = null

  private ensureContainer() {
    if (!this.container) {
      this.container = document.createElement('div')
      this.container.id = 'toast-container'
      document.body.appendChild(this.container)
    }
    return this.container
  }

  show(options: ToastOptions) {
    const container = this.ensureContainer()
    const wrapper = document.createElement('div')
    container.appendChild(wrapper)

    const app = createApp({
      render() {
        return h(NotificationToast, {
          ...options,
          onClose: () => {
            app.unmount()
            container.removeChild(wrapper)
          }
        })
      }
    })

    app.mount(wrapper)
  }

  success(title: string, message: string) {
    this.show({ type: 'success', title, message })
  }

  error(title: string, message: string) {
    this.show({ type: 'error', title, message, duration: 7000 })
  }

  warning(title: string, message: string) {
    this.show({ type: 'warning', title, message })
  }

  info(title: string, message: string) {
    this.show({ type: 'info', title, message })
  }
}

const toast = new ToastManager()

export const useToast = () => {
  return toast
}

export { toast }
